var map = {
	"./BarrasOff.svg": 9218,
	"./BarrasOn.svg": 4466,
	"./Dots_INE_Down.svg": 7156,
	"./Dots_INE_Top.svg": 3933,
	"./HeatmapOff.svg": 3422,
	"./HeatmapOn.svg": 1735,
	"./MapaOff.svg": 7979,
	"./MapaOn.svg": 8721,
	"./TreemapOff.svg": 1789,
	"./TreemapOn.svg": 3308,
	"./background7.svg": 9914,
	"./download.svg": 3694,
	"./logo-ine-white.svg": 2252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5442;